import {
  DEFAULT_SEARCH_VIEW,
  ITEMS_PER_PAGE,
  MAX_AGE,
  MIN_AGE,
} from '@kamernet/constants/Search';
import {
  RentalPriceID,
  SurfaceMinimumID,
} from '@kamernet/core/ApiClient/Kamernet';

import { TenantsSearchAllFilters } from '../types';

export function getEmptyTenantsSearchAllFilters(): TenantsSearchAllFilters {
  return {
    pageNo: null,
    tenantsPerPage: ITEMS_PER_PAGE,
    searchView: DEFAULT_SEARCH_VIEW,
    maxRent: RentalPriceID.Empty,
    minSize: SurfaceMinimumID.Empty,
    citySlug: null,
    cityName: null,
    furnishings: null,
    availabilityPeriods: null,
    suitableForNumberOfPersons: null,
    suitableForGenders: null,
    suitableForAgeRange: [MIN_AGE, MAX_AGE],
    suitableForWorkStatuses: null,
    isSmokingInsideAllowed: null,
    isPetsInsideAllowed: null,
    roommateNumberMax: null,
    roommateGenders: null,
    tenantsWithImageOnly: true,
  };
}
